import React from 'react';
import Icon from '../Icon/Icon';

type PasswordInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(({ className = '', ...props }, ref) => {
  const [visible, setVisible] = React.useState(false);
  return (
    <div className="form-input-wrap">
      <input {...props} ref={ref} type={visible ? 'text' : 'password'} className={`${className} form-password-input`} />
      <button type="button" className="password-toggle" onClick={() => setVisible((value) => !value)} aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}>
        <Icon name={visible ? 'eye-off' : 'eye'} />
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
